<div class="c100 {{ size }} p{{ percentage.toFixed(0) }} {{ colorClass }}">
  <span>{{ label }}</span>
  <div class="slice">
    <div class="bar"></div>
    <div class="fill"></div>
  </div>
</div>
